import { render, staticRenderFns } from "./policy-tab.vue?vue&type=template&id=02f47c7c&scoped=true&"
import script from "./policy-tab.vue?vue&type=script&lang=js&"
export * from "./policy-tab.vue?vue&type=script&lang=js&"
import style0 from "./policy-tab.vue?vue&type=style&index=0&id=02f47c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f47c7c",
  null
  
)

export default component.exports